export const getImageUrl = (url: string | undefined | null) => {
  return url ? (process.env.NEXT_PUBLIC_API_FILE_BASE_URL as string) + url : '/';
};
